import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { PrimeNgModule } from './modules/primng.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialExampleModule } from './modules/material.module';
import { UploadDocumentComponent } from './component/upload-document/upload-document.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgSelectModule } from '@ng-select/ng-select';
import { HeaderComponent } from './component/layoutComponent/header/header.component';
import { AppMenuitemComponent } from './component/layoutComponent/sidebar/menuItem';
import { SidebarComponent } from './component/layoutComponent/sidebar/sidebar.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { BreadcrumbComponent } from './component/layoutComponent/breadcrumb/breadcrumb.component';
import { FooterComponent } from './component/layoutComponent/footer/footer.component';
import { SliderComponent } from './component/layoutComponent/slider/slider.component';
import { ShareWithUsComponent } from './component/share-with-us/share-with-us.component';
import { RatingComponent } from './component/rating/rating.component';
import { ArticlesDataComponent } from './component/articles-data/articles-data.component';
import { GetTokenComponent } from './component/get-token/get-token.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InteractionComponent } from './component/interaction/interaction.component';

import { ChangeFont } from './directive/change-font.directive';
import { SkeltonFrameComponent } from './component/skelton-frame/skelton-frame.component';
import {NgxPaginationModule} from 'ngx-pagination'; // <-- import the module
import { SharedPipesModule } from './pipes/shared-pipes.module';
import { environment } from '../../environments/environment';

import { CountUpComponent } from './component/count-up/count-up.component';
import { HijriDatePipe } from './pipes/hijri_gorgian_Date.pipe';
import { ScrollToTopDirective } from './directive/scroll-to-top.directive';
import { AddQueryParamDirective } from './directive/add-query-param.directive';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { ShareLinkDirective } from './directive/share-link.directive';
import { FacebookShareDirective } from './directive/facebook-share.directive';
import { TwitterShareDirective } from './directive/twitter-share.directive';
import { WhatsappShareDirective } from './directive/whatsapp-share.directive';
import { EmailShareDirective } from './directive/email-share.directive';
import { CutTextDirective } from './directive/cut-text.directive';
import { HijriDatePipeSA } from './pipes/hijri_Date.pipe';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown'; 
export function createSharedTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');

}


@NgModule({
    declarations: [UploadDocumentComponent,
        SidebarComponent, HeaderComponent, ChangeFont,
        AppMenuitemComponent, HijriDatePipe, HijriDatePipeSA,
        BreadcrumbComponent, ArticlesDataComponent,
        InteractionComponent,
        FooterComponent, SliderComponent,
        ShareWithUsComponent, RatingComponent, GetTokenComponent,
        InteractionComponent, ScrollToTopDirective, ShareLinkDirective, FacebookShareDirective, TwitterShareDirective, WhatsappShareDirective, EmailShareDirective, CutTextDirective,
    ],
    exports: [MaterialExampleModule, PrimeNgModule, NgxPaginationModule, ReactiveFormsModule, NgxSpinnerModule, NgxDropzoneModule, NgSelectModule,
        NgbDropdownModule, ArticlesDataComponent, NgbModule, ChangeFont, NgxSkeletonLoaderModule,
        NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule, FacebookShareDirective, CutTextDirective, HijriDatePipe, HijriDatePipeSA, ScrollToTopDirective,
        SidebarComponent, HeaderComponent, FooterComponent, InteractionComponent,
        AppMenuitemComponent, SliderComponent, ShareWithUsComponent, RatingComponent,
        BreadcrumbComponent, TranslateModule, FormsModule, UploadDocumentComponent, TwitterShareDirective, WhatsappShareDirective, EmailShareDirective],
    imports: [FormsModule, ReactiveFormsModule, PrimeNgModule, NgxSpinnerModule.forRoot({ type: 'ball-pulse' }),
        NgbModule, NgxSkeletonLoaderModule, NgxPaginationModule, BsDropdownModule.forRoot(),
        CommonModule, MaterialExampleModule, NgbDropdownModule, NgxDropzoneModule, NgSelectModule,
        NgxGoogleAnalyticsModule.forRoot(environment.google_trackingId), NgxGoogleAnalyticsRouterModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: (createSharedTranslateLoader),
                deps: [HttpClient]
            },
            isolate: true
        }), SkeltonFrameComponent]
})
export class SharedModule { }
